import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  host: { 'class': 'header' }
})
export class HeaderComponent implements OnInit {
  @Input()
  menuState = false;

  @Output()
  openMenu = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  toogleMenu() {
    this.menuState = !this.menuState;
    this.openMenu.next(this.menuState);
  }
}
